const CmsUserComponentUtils = {
    observerUserComponentByLocationChange: function(node, cb) {
        node.addEventListener('cms-user-component-render', function() {
            cb(node);
        });
    },
    onUserComponentRender: function(node, cb) {
        const warnForNode = 'CmsUserComponentUtils: node paramater must be an object.',
              warnForCb = 'CmsUserComponentUtils: cb parameter must by an function.',
              loaded = 'loaded';

        if (typeof node !== 'object') return console.warn(warnForNode);
        if (typeof cb !== 'function') return console.warn(warnForCb);

        if (node.hasAttribute(loaded) && node.getAttribute(loaded) === 'yes') {
            cb(node);
        } else {
            this.observerUserComponentByLocationChange(node, cb);
        }
    },
    onUserComponentSettled: function(node, onLoaded, onNotLoaded) {
        const dataLoaded = 'data-loaded';
        if (!node.hasAttribute(dataLoaded)) {
            onLoaded && this.observerUserComponentByLocationChange(node, onLoaded);
            onNotLoaded && node.addEventListener('cms-user-component-no-render', () => onNotLoaded(node));
        } else {
            node.getAttribute(dataLoaded) === 'yes'
                ? onLoaded && onLoaded(node)
                : onNotLoaded && onNotLoaded(node);
        }
    }
};
